export default __webpack_public_path__ + "static/media/icon_event.d9c7c0bb.svg";